import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

interface PdfPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  url?: string;
  html?: string;
}

const PdfPreviewModal = ({
  isOpen,
  onClose,
  url,
  html,
}: PdfPreviewModalProps) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setLoading(true);
    }
  }, [isOpen, url, html]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader
        toggle={onClose}
        className="fw-medium fs-16 text-black2D p-3 bg-greyF5"
      >
        Preview
      </ModalHeader>

      <ModalBody
        style={{ minHeight: "80vh", padding: 0, position: "relative" }}
      >
        {/* Loader */}
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
            }}
          >
            <Spinner color="primary" className="ms-4" />
            <div className="mt-2 text-center">Loading preview...</div>
          </div>
        )}

        {/* Iframe */}
        {(url || html) && (
          <iframe
            src={url || undefined}
            srcDoc={!url ? html : undefined}
            title="PDF Preview"
            onLoad={() => setLoading(false)}
            style={{
              width: "100%",
              height: "80vh",
              border: "none",
              visibility: loading ? "hidden" : "visible",
            }}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default React.memo(PdfPreviewModal);
